import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P85-E1',
    audio: '',
    video: '',
    component: T6,
    checkUppercase: true,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page85/E1/Key/answerKey.png',
    inputSize: 49,
    // titleQuestion: [{ num: '3', title: 'Listen and write. Then listen again and repeat. <headphone name="25" src="img/FriendsPlus/Page83/Audio/tieude-e2-p83.mp3"></headphone>', color: "#5B5A5D" }],
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page85/E1/1.jpg' /> </div>
          <div style=" position: absolute; top: 46px; left: 757px; "><input id='0' /></div>
          <div style=" position: absolute; top: 102px; left: 178px; "><input id='1' /></div>
          <div style=" position: absolute; top: 100px; left: 687px; "><input id='2' /></div>
          <div style=" position: absolute; top: 156px; left: 309px; "><input id='3' /></div>
          <div style=" position: absolute; top: 153px; left: 650px; "><input id='4' /></div>
          <div style=" position: absolute; top: 209px; left: 280px; "><input id='5' /></div>
        </div>
        `,
        answer: [
          "or",
          "and",
          "or",
          "or",
          "and",
          "and",
        ],
      },
    ],
  },
  2: {
    unit: 'Unit 12',
    id: 'WB3-U12-P85-E2',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page85/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page85/E2/2.jpg' },
      ]
    ]
  },
  3: {
    unit: 'Unit 12',
    id: 'WB3-U12-P85-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter:true,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page85/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page85/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page85/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page85/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page85/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page85/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page85/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page85/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/19.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/20.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page85/E3/21.jpg' },
        { url: 'img/FriendsPlus/Page85/E3/22.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E3/23.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page85/E3/24.jpg' },
      ],

    ]
  },




}
export default json;